function noop() {}

exports.noop = noop;